import React from "react";
import { Chip } from "@material-ui/core";
import { TableFilterTypesEnum } from "../../../../../Enums";

const expression =
  /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
const regex = new RegExp(expression);

export const DeveloperCampaignsHeaderData = [
  {
    id: 1,
    label: "project-name",
    input: "propertyName",
    isSortable: false,
  },
  {
    id: 2,
    label: "campaign-ID",
    input: "propertyCampaignId",
    filterType: TableFilterTypesEnum.numberInput.key,
    searchableKey: "campaignId",
    isSortable: false,
  },
  {
    id: 3,
    label: "campaign-name",
    input: "name",
    filterType: TableFilterTypesEnum.textInput.key,
    searchableKey: "campaignName",
    isSortable: false,
  },
  {
    id: 4,
    label: "campaign-manager",
    input: "campaignManagerName",
    isSortable: false,
  },
  {
    id: 5,
    label: "start-date",
    input: "campaignStartDate",
    isSortable: false,
    isDate: true,
    dateFormat: "DD/MM/YYYY",
  },
  {
    id: 6,
    label: "end-date",
    input: "campaignEndDate",
    isSortable: false,
    isDate: true,
    dateFormat: "DD/MM/YYYY",
  },
  {
    id: 7,
    label: "campaign-languages",
    input: "propertyCampaignLanguages",
    isSortable: false,
    component: (data) => (
      <span>
        {data?.propertyCampaignLanguages?.map((item) => (
          <span className="table-capsule mr-1 fw-simi-bold">
            {item.languageName || ""}
          </span>
        ))}
      </span>
    ),
  },
  {
    id: 8,
    label: "media",
    input: "mediaTypeName",
    filterType: TableFilterTypesEnum.textInput.key,
    searchableKey: "MediaTypeName",
    isSortable: false,
  },
  {
    id: 9,
    label: "media-details",
    input: "mediaDetailsName",
    isSortable: false,
  },
  {
    id: 10,
    label: "media-link",
    input: "mediaUrl",
    isSortable: false,
    component: (data) =>
      (
        <span>
          {((data && data.mediaUrl) || "").match(regex) ? (
            <a href={data.mediaUrl} target="_blank" rel="noopener noreferrer">
              {data.mediaUrl}
            </a>
          ) : (
            <span>{data?.mediaUrl || ""}</span>
          )}
        </span>
      ) || <span />,
  },
  {
    id: 11,
    label: "campaign-status",
    isSortable: false,
    component: (item) =>
      <span>{item.campaignStatus ? "Active" : "In-Active"}</span> || <span />,
  },
  {
    id: 12,
    label: "budget-amount",
    input: "budgetAmount",
    isSortable: false,
    component: (item) => <span>{item.budgetAmount ?? "-"}</span> || <span />,
  },
  {
    id: 13,
    label: "spent-amount",
    input: "spentAmount",
    isSortable: false,
    component: (item) => <span>{item.spentAmount ?? "-"}</span> || <span />,
  },
  {
    id: 15,
    label: "total-number-of-leads",
    input: "actualNumberOfLeads",
    isSortable: false,
    component: (item) =>
      <span>{item.actualNumberOfLeads ?? 0}</span> || <span />,
  },
  {
    id: 16,
    label: "transacted-leads",
    input: "transactedLeads",
    isSortable: false,
    component: (item) => <span>{item.transactedLeads ?? 0}</span> || <span />,
  },
  {
    id: 17,
    label: "transaction-value",
    input: "transactionValue",
    isSortable: false,
    component: (item) => <span>{item.transactionValue ?? 0}</span> || <span />,
  },
  {
    id: 18,
    label: "CPR (Cost per Lead)",
    input: "crp",
    isSortable: false,
    component: (item) => <span>{item.crp ?? 0}</span> || <span />,
  },
  {
    id: 19,
    label: "campaign-revenue",
    input: "campaignsRevenue",
    isSortable: false,
    component: (item) => <span>{item.campaignsRevenue ?? 0}</span> || <span />,
  },
  {
    id: 20,
    label: "Meta Leads Pulled",
    input: "metaLeadsPulled",
    isHiddenFilter: true,
    isSortable: false,
  },
  {
    id: 21,
    label: "Meta Spend (AED)",
    input: "metaSpendAED",
    isHiddenFilter: true,
    isSortable: false,
  },
  {
    id: 22,
    label: "Meta CPL (AED)",
    input: "metaCplAED",
    isHiddenFilter: true,
    isSortable: false,
  },
  {
    id: 23,
    label: "PlatformCampaign ID",
    input: "platformCampaignId",
    isHiddenFilter: true,
    isSortable: false,
    component: (data) =>
      (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "2px",
            alignItems: "center",
            minHeight: 32,
          }}
        >
          {Array.isArray(data?.platformCampaignId)
            ? data.platformCampaignId.map((id) => (
                <Chip
                  key={id}
                  label={id}
                  size="small"
                  style={{ marginRight: 2, marginLeft: 2, marginBottom: 2 }}
                />
              ))
            : null}
        </div>
      ) || <span />,
  },
];
